import React from 'react';
import { useCurrentUserQuery } from 'store/api';
import { Trans } from '@lingui/macro';
import { useAppSelector } from 'store/';
import { getAuthStore } from 'store/slices';
import { Container, Content, Description, Title } from './styled';

export const BlockedUser = ({ children }: { children: React.ReactNode }) => {
  const { isLoggedIn } = useAppSelector(getAuthStore);

  const { data, isLoading } = useCurrentUserQuery(undefined, {
    skip: !isLoggedIn,
  });

  if (!isLoading && data?.user_profile.is_blocked) {
    return (
      <Container>
        <Content>
          <Title>
            <Trans>Blocked</Trans>
          </Title>
          <Description>
            <Trans>Your account has been blocked.</Trans>
          </Description>
        </Content>
      </Container>
    );
  }

  return <>{children}</>;
};
